import { ref, nextTick } from 'vue';
import HttpRequest from '@/util/axios.config';
import { formatNumber } from '@/methods/base';
const server = {
    CHN: ['CHN'],
    JPN: ['JPN'],
    INDIA: ['IND'],
    RU: ['RUS'],
    INC: ['ARE', 'BHR', 'CYP', 'IRN', 'IRQ', 'ISR', 'JOR', 'KWT',
        'LBN', 'OMN', 'PSE', 'QAT', 'SAU', 'SYR', 'TUR', 'AZE', 'GEO'],
    ASIA: [
        'PHL', 'THA', 'IND', 'KOR',
        'BGD', 'SPI', 'MMR', 'IDN', 'SGP', 'RUS', 'MYS', 'AZE',
        'ARM', 'VNM', 'TJK', 'UZB', 'TLS', 'KHM', 'BTN', 'GEO', 'KAZ',
        'JOR', 'TKM', 'MNG', 'LAO',
        'PAK', 'BRN', 'AFG', 'PRK', 'NPL',
        'LKA', 'KGZ'
    ],
    EUR: [
        'FIN', 'SWE', 'NOR', 'ISL', 'DNK', 'EST', 'LVA', 'LTU',
        'BLR', 'UKR', 'MDA', 'POL', 'CZE', 'SVK', 'HUN',
        'DEU', 'AUT', 'CHE', 'LIE', 'GBR', 'IRL', 'NLD', 'BEL',
        'LUX', 'FRA', 'MCO', 'ROU', 'BGR', 'SRB', 'MKD', 'ALB',
        'GRC', 'SVN', 'HRV', 'MNE', 'MLT', 'BIH', 'ITA', 'VAT',
        'SMR', 'ESP', 'PRT', 'AND', 'FRO',
        'SAU', 'IRN', 'IRQ', 'KWT', 'ARE', 'OMN', 'QAT', 'BHR',
        'TUR', 'ISR', 'SYR', 'LBN', 'JOR', 'CYP', 'YEM', 'EGY',
        'LBY', 'TUN', 'DZA', 'MAR'
    ],
    USA: [
        'CAN', 'USA', 'MEX', 'GRL', 'GTM', 'BLZ', 'SLV', 'HND', 'NIC',
        'CRI', 'PAN', 'BHS', 'CUB', 'JAM', 'HTI', 'DOM', 'ATG', 'KNA',
        'DMA', 'LCA', 'VCT', 'GRD', 'BRB', 'TTO', 'PRI', 'VIR', 'COL',
        'VEN', 'GUY', 'SUR', 'ECU', 'PER', 'BOL', 'BRA', 'CHL', 'ARG',
        'URY', 'PRY', 'UMI'
    ],
    AUS: ['AUS', 'NZL']
};
const getGlobalMap = (globalData, type) => {
    const serverData = [];
    globalData.forEach((item) => {
        if (server[type].includes(item.Code)) {
            serverData.push(item);
        }
    });
    const columns = [
        ['Country code', 'AFG', 'ALB', 'DZA', 'ASM', 'AND', 'AGO', 'ATG', 'ARG', 'ARM', 'AUS', 'AUT', 'AZE', 'BHS',
            'BHR', 'BGD', 'BRB', 'BLR', 'BEL', 'BLZ', 'BEN', 'BTN', 'BOL', 'BIH', 'BWA', 'BRA', 'BRN', 'BGR', 'BFA', 'BDI',
            'KHM', 'CMR', 'CAN', 'CPV', 'CAF', 'TCD', 'CHL', 'CHN', 'COL', 'COM', 'COG', 'COD', 'CRI', 'CIV', 'HRV', 'CUB',
            'CYP', 'CZE', 'DNK', 'DJI', 'DMA', 'DOM', 'ECU', 'EGY', 'SLV', 'GNQ', 'ERI', 'EST', 'ETH', 'FRO', 'FJI', 'FIN',
            'FRA', 'GAB', 'GMB', 'GEO', 'DEU', 'GHA', 'GRC', 'GRL', 'GRD', 'GUM', 'GTM', 'GIN', 'GNB', 'GUY', 'HTI', 'HND',
            'HUN', 'ISL', 'IND', 'IDN', 'IRN', 'IRQ', 'IRL', 'ISR', 'ITA', 'JAM', 'JPN', 'JOR', 'KAZ', 'KEN', 'KIR',
            'PRK', 'KOR', '-99', 'KWT', 'KGZ', 'LAO', 'LVA', 'LBN', 'LSO', 'LBR', 'LBY', 'LIE', 'LTU', 'LUX', 'MRT', 'MKD',
            'MDG', 'MWI', 'MYS', 'MDV', 'MLI', 'MLT', 'MHL', 'MRT', 'MUS', 'MEX', 'FSM', 'MDA', 'MCO', 'MNG', 'MNE', 'MAR', 'MOZ',
            'MMR', 'NAM', 'NPL', 'NLD', '-99', 'NZL', 'NIC', 'NER', 'NGA', 'MNP', 'NOR', 'OMN', 'PAK', 'PLW', 'PAN', 'PNG', 'PRY',
            'PER', 'PHL', 'POL', 'PRT', 'PRI', 'QAT', 'ROU', 'RUS', 'RWA', 'ASM', 'SMR', 'STP', 'SAU', 'SEN', 'SRB', 'SYC', 'SLE',
            'SGP', 'SVK', 'SVN', 'SLB', 'SOM', 'ZAF', 'SSD', 'ESP', 'LKA', 'KNA', 'LCA', 'VCT', 'SDN', 'SUR', 'SWZ', 'SWE',
            'CHE', 'SYR', 'TJK', 'TZA', 'THA', 'TLS', 'TGO', 'TON', 'TTO', 'TUN', 'TUR', 'TKM', 'TUV', 'UGA', 'UKR', 'ARE',
            'GBR', 'USA', 'URY', 'UZB', 'VUT', 'VEN', 'VNM', 'VIR', 'ESH', 'YEM', 'ZMB', 'ZWE'],
        ['Country name', 'Afghanistan', 'Albania', 'Algeria', 'American Samoa', 'Andorra', 'Angola', 'Antigua and Barbuda',
            'Argentina', 'Armenia', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh',
            'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bhutan', 'Bolivia', 'Bosnia and Herzegovina',
            'Botswana', 'Brazil', 'Brunei', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Cambodia', 'Cameroon', 'Canada',
            'Cape Verde', 'Central African Republic', 'Chad', 'Chile', 'China', 'Colombia', 'Comoros',
            'Republic of Congo', 'Democratic Republic of the Congo', 'Costa Rica', 'Ivory Coast', 'Croatia', 'Cuba', 'Cyprus',
            'Czech Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'Ecuador', 'Egypt',
            'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Ethiopia', 'Faroe Islands', 'Fiji', 'Finland',
            'France', 'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Greece', 'Greenland',
            'Grenada', 'Guam', 'Guatemala', 'Guinea', 'Guinea Bissau', 'Guyana', 'Haiti', 'Honduras',
            'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran', 'Iraq', 'Ireland', 'Israel', 'Italy',
            'Jamaica', 'Japan', 'Jordan', 'Kazakhstan', 'Kenya', 'Kiribati', 'North Korea', 'South Korea', 'Kosovo', 'Kuwait',
            'Kyrgyzstan', 'Laos', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg',
            'Macedonia', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands',
            'Mauritania', 'Mauritius', 'Mexico', 'Federated States of Micronesia', 'Moldova', 'Monaco', 'Mongolia', 'Montenegro',
            'Morocco', 'Mozambique', 'Myanmar', 'Namibia', 'Nepal', 'Netherlands', 'Northern Cyprus', 'New Zealand', 'Nicaragua', 'Niger',
            'Nigeria', 'Northern Mariana Islands', 'Norway', 'Oman', 'Pakistan', 'Palau', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru',
            'Philippines', 'Poland', 'Portugal', 'Puerto Rico', 'Qatar', 'Romania', 'Russia', 'Rwanda', 'Samoa', 'San Marino',
            'Sao Tome and Principe', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore', 'Slovakia',
            'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'South Sudan', 'Spain', 'Sri Lanka', 'Saint Kitts and Nevis',
            'Saint Lucia', 'Saint Vincent and the Grenadines', 'Sudan', 'Suriname', 'Swaziland', 'Sweden',
            'Switzerland', 'Syria', 'Tajikistan', 'Tanzania', 'Thailand', 'East Timor', 'Togo', 'Tonga', 'Trinidad and Tobago',
            'Tunisia', 'Turkey', 'Turkmenistan', 'Tuvalu', 'Uganda', 'Ukraine', 'United Arab Emirates',
            'United Kingdom', 'United States of America', 'Uruguay', 'Uzbekistan', 'Vanuatu', 'Venezuela', 'Vietnam', 'Virgin Islands',
            'Western Sahara', 'Yemen', 'Zambia', 'Zimbabwe'],
        ['Global Business', null]
    ];
    columns[0].forEach((item, index) => {
        if (index > 0) {
            columns[2][index] = null;
        }
    });
    let maxNum = 0;
    let minNum = Number(serverData[0].Num);
    serverData.forEach((item) => {
        if (columns[0].indexOf(item.Code.toUpperCase()) !== -1) {
            columns[2][columns[0].indexOf(item.Code.toUpperCase())] = item.Num;
        }
        if (Number(item.Num) > maxNum) {
            maxNum = Number(item.Num);
        }
        if (Number(item.Num) < minNum) {
            minNum = Number(item.Num);
        }
    });
    const averageNum = (maxNum - minNum) / 4;
    const data = [[], [], [], [], [], []];
    columns[2].forEach((item, index) => {
        if (index > 0 && item) {
            switch (true) {
                case Number(item) <= minNum:
                    data[0].push({
                        code: columns[0][index],
                        value: Number(item)
                    });
                    break;
                case Number(item) <= (averageNum + minNum):
                    data[1].push({
                        code: columns[0][index],
                        value: Number(item)
                    });
                    break;
                case Number(item) <= (2 * averageNum + minNum):
                    data[2].push({
                        code: columns[0][index],
                        value: Number(item)
                    });
                    break;
                case Number(item) <= (3 * averageNum + minNum):
                    data[3].push({
                        code: columns[0][index],
                        value: Number(item)
                    });
                    break;
                case Number(item) <= (4 * averageNum + minNum):
                    data[4].push({
                        code: columns[0][index],
                        value: Number(item)
                    });
                    break;
                default:
                    break;
            }
        }
        else {
            data[5].push(columns[0][index]);
        }
    });
    console.log('----', data);
    Highcharts.mapChart('global-container', {
        chart: {
            borderWidth: 0,
            backgroundColor: 'transparent',
            type: 'map',
            marginRight: 100,
            marginBottom: (120 * document.body.clientHeight) / 1080
        },
        colors: ['transparent', '#803FFF', '#23D26A',
            '#16D3A6', '#04C8DC', '#006CFF'
        ],
        title: {
            text: ''
        },
        credits: {
            enabled: false
        },
        exporting: {
            enabled: false
        },
        legend: {
            enabled: false,
            align: 'right',
            verticalAlign: 'bottom',
            floating: true,
            layout: 'vertical',
            valueDecimals: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.12)',
            borderColor: 'rgba(255, 255, 255, 0.15)',
            borderWidth: 1,
            symbolRadius: 0,
            symbolHeight: 8,
            shadow: 'inset 0px 1px 15px 0px #1F5E89',
            itemStyle: {
                color: '#fff',
                x: 50
            },
            x: -12,
            reversed: true,
            itemMarginBottom: 5,
            width: 100,
            itemHoverStyle: {
                color: '#02A1FC'
            }
        },
        plotOptions: {
            map: {
                allAreas: false,
                joinBy: ['iso-a3', 'code'],
                mapData: Highcharts.maps['custom/world'],
                borderColor: '#006cff',
                tooltip: {
                    headerFormat: '',
                    pointFormat: '{point.name}'
                }
            }
        },
        series: [{
                name: '',
                data: Highcharts.map(data[5], (code) => ({
                    code
                })),
                showInLegend: false
            }, {
                name: minNum.toFixed(2),
                data: data[0]
            }, {
                name: (averageNum + minNum).toFixed(2),
                data: data[1],
                showInLegend: type !== 'CHN'
            }, {
                name: (averageNum * 2 + minNum).toFixed(2),
                data: data[2],
                showInLegend: type !== 'CHN'
            }, {
                name: (averageNum * 3 + minNum).toFixed(2),
                data: data[3],
                showInLegend: type !== 'CHN'
            }, {
                name: (averageNum * 4 + minNum).toFixed(2),
                data: data[4],
                showInLegend: type !== 'CHN'
            }]
    });
};
const getPieChart = (data) => {
    Highcharts.chart('pie-container', {
        chart: {
            type: 'pie',
            backgroundColor: 'transparent'
        },
        colors: ['#006CFF', '#0094FF', '#04C8DC',
            '#00F6BB', '#00CD0B', '#803FFF', '#522BFF'
        ],
        legend: {
            align: 'right',
            verticalAlign: 'top',
            layout: 'vertical',
            backgroundColor: 'transparent',
            borderColor: 'transparent',
            borderWidth: 0,
            symbolRadius: 0,
            symbolHeight: 8,
            shadow: 'inset 0px 1px 15px 0px #1F5E89',
            itemStyle: {
                color: '#fff',
                x: 50
            },
            itemMarginBottom: 10,
            y: 10,
            itemHoverStyle: {
                color: '#02A1FC'
            }
        },
        title: {
            text: '',
            style: {
                color: 'white'
            }
        },
        credits: {
            enabled: false
        },
        plotOptions: {
            pie: {
                dataLabels: {
                    enabled: true,
                    style: {
                        fontWeight: 'bold',
                        color: 'white',
                        textShadow: '0px 1px 2px black'
                    },
                    format: '{point.percentage:.1f} %'
                },
                showInLegend: true,
                borderColor: 'transparent'
            }
        },
        series: [{
                type: 'pie',
                // name: '',
                innerSize: '50%',
                colorByPoint: true,
                data
            }],
        exporting: {
            enabled: false
        }
    });
};
const getColumnCountChart = (container, data, colors) => {
    Highcharts.chart(container, {
        chart: {
            type: 'column',
            backgroundColor: 'transparent'
        },
        title: {
            text: ''
        },
        colors,
        xAxis: {
            type: 'category',
            labels: {
                step: Math.floor((data[0].data.length - 3) / 2),
                style: {
                    color: '#ffffff'
                }
            },
            lineColor: '#02A3FF'
        },
        yAxis: {
            min: 0,
            title: {
                text: ''
            },
            gridLineColor: 'rgba(255, 255, 255, 0.1)',
            lineColor: '#02A3FF',
            lineWidth: 1
        },
        legend: {
            align: 'right',
            verticalAlign: 'top',
            symbolRadius: 0,
            itemStyle: {
                color: '#fff'
            },
            itemHoverStyle: {
                color: '#02A1FC'
            }
        },
        plotOptions: {
            series: {
                borderColor: 'transparent'
            }
        },
        credits: {
            enabled: false
        },
        exporting: {
            enabled: false
        },
        series: data
    });
};
const getAreaChart = (container, data, colors, style = null) => {
    let maxY = 0;
    data.forEach((item, index) => {
        let tempColors = colors[index].split(',');
        tempColors.splice(tempColors.length - 1, 1, '0)');
        tempColors = tempColors.join(',');
        /* eslint-disable no-param-reassign */
        item.fillColor = {
            color: 'white',
            linearGradient: {
                x1: 0, y1: 0, x2: 0, y2: 1
            },
            stops: [
                [0, style ? colors[index] : 'rgba(0,0,0,0)'],
                [1, style ? tempColors : 'rgba(0, 0, 0, 0)']
            ]
        };
        item.fillOpacity = 0.1;
        item.marker = {
            fillColor: '#D8D8D8',
            lineColor: colors[index],
            lineWidth: 2,
            radius: 4,
            symbol: 'circle'
        };
        item.data.forEach((innerItem) => {
            if (Number(innerItem[1]) > maxY) {
                // eslint-disable-next-line prefer-destructuring
                maxY = innerItem[1];
            }
        });
    });
    console.log('max: ', maxY);
    Highcharts.chart(container, {
        chart: {
            type: 'area',
            backgroundColor: 'transparent'
        },
        title: {
            text: ''
        },
        colors,
        xAxis: {
            type: 'category',
            labels: {
                step: Math.floor((data[0].data.length - 3) / 2),
                style: {
                    color: '#ffffff'
                }
            },
            lineColor: '#02A3FF'
        },
        yAxis: {
            min: 0,
            max: maxY,
            tickAmount: 4,
            title: {
                text: ''
            },
            gridLineColor: 'rgba(255, 255, 255, 0.1)',
            lineColor: '#02A3FF',
            lineWidth: 1
        },
        legend: {
            align: 'right',
            verticalAlign: 'top',
            symbolRadius: 0,
            itemStyle: {
                color: '#fff'
            },
            itemHoverStyle: {
                color: '#02A1FC'
            }
        },
        credits: {
            enabled: false
        },
        exporting: {
            enabled: false
        },
        series: data
    });
};
const cardInfo = ref({
    doorLogs: {
        title: 'Door Logs',
        icon: require('@/assets/image/all-open-door-count.png'),
        text: ''
    },
    todayDoorLogs: {
        title: 'Daily - Door Logs',
        icon: require('@/assets/image/today-open-door-count.png'),
        text: ''
    },
    callLogs: {
        title: 'Call Logs',
        icon: require('@/assets/image/all-call-count.png'),
        text: ''
    },
    todayCallLogs: {
        title: 'Daily -  Call Logs',
        icon: require('@/assets/image/today-call-count.png'),
        text: ''
    },
    officeUsers: {
        title: 'Office users',
        icon: require('@/assets/image/active-app-count.png'),
        text: ''
    },
    devices: {
        title: 'Devices on the cloud',
        icon: require('@/assets/image/registered-device-count.png'),
        text: ''
    },
    devicesOnline: {
        title: 'Devices online',
        icon: require('@/assets/image/online-device-count.png'),
        text: '',
        rightTitle: ''
    },
    liveView: {
        title: 'Live View',
        icon: require('@/assets/image/all-live-view-count.png'),
        text: ''
    },
    families: {
        title: 'Families',
        icon: require('@/assets/image/active-family-count.png'),
        text: '',
        textColor: '#00CD0B'
    },
    monthFeeUserNum: {
        title: 'Residential',
        icon: require('@/assets/image/month-user-num.png'),
        text: '',
        textColor: '#13CEA1'
    },
    monthFeeUserNumTotal: {
        title: 'Subscribers',
        icon: require('@/assets/image/month-user-num.png'),
        text: '',
        textColor: '#13CEA1'
    },
    monthFeeOfficeUserNum: {
        title: 'Office',
        icon: require('@/assets/image/month-user-num.png'),
        text: '',
        textColor: '#13CEA1'
    },
    residentialAppNum: {
        title: 'Residential',
        icon: require('@/assets/image/app-users-count.png'),
        text: '',
        textColor: '#13CEA1'
    },
    officeAppNum: {
        title: 'Office',
        icon: require('@/assets/image/app-users-count.png'),
        text: '',
        textColor: '#13CEA1'
    },
    totalAppNum: {
        title: 'App users',
        icon: require('@/assets/image/app-users-count.png'),
        text: '',
        textColor: '#13CEA1'
    },
    residentialSites: {
        title: 'Residential',
        icon: require('@/assets/image/site.png'),
        text: '',
        textColor: '#13CEA1'
    },
    officeSites: {
        title: 'Office',
        icon: require('@/assets/image/site.png'),
        text: '',
        textColor: '#13CEA1'
    },
    totalProjects: {
        title: 'Sites',
        icon: require('@/assets/image/site.png'),
        text: '',
        textColor: '#13CEA1'
    },
    residentialDoors: {
        title: 'Residential',
        icon: require('@/assets/image/door-relay.png'),
        text: '',
        textColor: '#13CEA1'
    },
    officeDoors: {
        title: 'Office',
        icon: require('@/assets/image/door-relay.png'),
        text: '',
        textColor: '#13CEA1'
    },
    totalDoors: {
        title: 'Doors',
        icon: require('@/assets/image/door-relay.png'),
        text: '',
        textColor: '#13CEA1'
    }
});
const totalUserNum = ref(0);
const timeData = ref({
    monthly: {
        users: [],
        subscribers: [],
        devices: [],
        callLogs: [],
        doorLogs: []
    },
    yearly: {
        users: [],
        subscribers: [],
        devices: [],
        callLogs: [],
        doorLogs: []
    }
});
const disList = ref([]);
const getData = (type, token) => {
    HttpRequest.get('getAkcsRegionData', token === '' ? {
        Region: type
    } : {
        Region: type,
        Token: token
    }, (res) => {
        const { data } = res;
        cardInfo.value.todayDoorLogs.text = formatNumber(data.TodayOpenDoorNum || '0');
        cardInfo.value.doorLogs.text = formatNumber(data.TotalOpenDoorNum || '0');
        cardInfo.value.todayCallLogs.text = formatNumber(data.TodayCallNum || '0');
        cardInfo.value.callLogs.text = formatNumber(data.TotalCallNum || '0');
        cardInfo.value.devicesOnline.text = formatNumber(data.DeviceOnline.online || '0');
        cardInfo.value.devicesOnline.rightTitle = `${data.DeviceOnline.rate ? '' : `(${data.DeviceOnline.rate})`}`;
        cardInfo.value.devices.text = formatNumber(data.RegisteredDeviceNum || '0');
        cardInfo.value.liveView.text = formatNumber(data.TotalLiveView || '0');
        cardInfo.value.families.text = formatNumber(data.ActiveFamilyNum || '0');
        cardInfo.value.officeUsers.text = formatNumber(data.OfficeNum || '0');
        cardInfo.value.monthFeeUserNum.text = formatNumber(data.MonthFeeUserNum || '0');
        cardInfo.value.monthFeeOfficeUserNum.text = formatNumber(data.MonthFeeOfficeUserNum || '0');
        cardInfo.value.monthFeeUserNumTotal.text = formatNumber(Number(data.MonthFeeUserNum || 0) + Number(data.MonthFeeOfficeUserNum || 0));
        cardInfo.value.residentialAppNum.text = formatNumber(data.TotalappsByStats.ResidentialAppNum || '0');
        cardInfo.value.officeAppNum.text = formatNumber(data.TotalappsByStats.OfficeAppNum || '0');
        // eslint-disable-next-line max-len
        cardInfo.value.totalAppNum.text = formatNumber(Number(data.TotalappsByStats.ResidentialAppNum || 0) + Number(data.TotalappsByStats.OfficeAppNum || 0));
        cardInfo.value.residentialSites.text = formatNumber(data.TotalProjectsByStats.ResidentialProjectNum || '0');
        cardInfo.value.officeSites.text = formatNumber(data.TotalProjectsByStats.OfficeProjectNum || '0');
        // eslint-disable-next-line max-len
        cardInfo.value.totalProjects.text = formatNumber(Number(data.TotalProjectsByStats.ResidentialProjectNum || 0) + Number(data.TotalProjectsByStats.OfficeProjectNum || 0));
        cardInfo.value.residentialDoors.text = formatNumber(data.TotalRelayByStats.ResidentialRelayNum || '0');
        cardInfo.value.officeDoors.text = formatNumber(data.TotalRelayByStats.OfficeRelayNum || '0');
        // eslint-disable-next-line max-len
        cardInfo.value.totalDoors.text = formatNumber(Number(data.TotalRelayByStats.ResidentialRelayNum || 0) + Number(data.TotalRelayByStats.OfficeRelayNum || 0));
        // 保存当前服务器下的代理商
        disList.value = [];
        const tempDisList = [];
        if (token === '') {
            res.data.disList.forEach((item) => {
                tempDisList.push({
                    label: item,
                    value: item
                });
            });
            disList.value = tempDisList;
        }
        const liveViewNum = [];
        const doorType = [];
        // callLogs 年月数据保存
        const callNum = [{
                name: 'Call logs',
                data: []
            }];
        data.GlobalMonthCallNumMonth.forEach((item) => {
            callNum[0].data.push([item.DateTime, Number(item.CallNum)]);
        });
        timeData.value.monthly.callLogs = callNum;
        const callNumYear = [{
                name: 'Call logs',
                data: []
            }];
        data.GlobalMonthCallNumYear.forEach((item) => {
            callNumYear[0].data.push([item.DateTime, Number(item.CallNum)]);
        });
        timeData.value.yearly.callLogs = callNumYear;
        // doorLogs 年月数据保存
        const doorNum = [{
                name: 'Door logs',
                data: []
            }];
        data.GlobalOpenDoorNumMonth.forEach((item) => {
            doorNum[0].data.push([item.DateTime, Number(item.DoorNum)]);
        });
        timeData.value.monthly.doorLogs = doorNum;
        const doorNumYear = [{
                name: 'Door logs',
                data: []
            }];
        data.GlobalOpenDoorNumYear.forEach((item) => {
            doorNumYear[0].data.push([item.DateTime, Number(item.DoorNum)]);
        });
        timeData.value.yearly.doorLogs = doorNumYear;
        data.LiveView.forEach((item) => {
            liveViewNum.push([item.DateTime, Number(item.LiveViewNum)]);
        });
        data.OpenDoorSuccessType.forEach((item) => {
            doorType.push({
                name: item.OpenDoorType,
                y: Number(item.OpenDoorNum)
            });
        });
        // device 年月数据保存
        const deviceNum = [{
                name: 'Online devices',
                data: []
            }, {
                name: 'Registered devices',
                data: []
            }];
        data.DeviceMonth.forEach((item) => {
            deviceNum[0].data.push([item.DateTime, Number(item.online_num)]);
            deviceNum[1].data.push([item.DateTime, Number(item.register_num)]);
        });
        timeData.value.monthly.devices = deviceNum;
        const deviceNumYear = [{
                name: 'Online devices',
                data: []
            }, {
                name: 'Registered devices',
                data: []
            }];
        data.DeviceYear.forEach((item) => {
            deviceNumYear[0].data.push([item.DateTime, Number(item.online_num)]);
            deviceNumYear[1].data.push([item.DateTime, Number(item.register_num)]);
        });
        timeData.value.yearly.devices = deviceNumYear;
        // users 年月数据保存
        const activeNum = [{
                name: 'Family users',
                data: []
            }, {
                name: 'Office users',
                data: []
            }];
        data.FamilyAndOFficeNumMonth.forEach((item) => {
            activeNum[0].data.push([item.DateTime, Number(item.FamilyNum)]);
            activeNum[1].data.push([item.DateTime, Number(item.OfficeNum)]);
        });
        timeData.value.monthly.users = activeNum;
        const activeNumYear = [{
                name: 'Family users',
                data: []
            }, {
                name: 'Office users',
                data: []
            }];
        data.FamilyAndOFficeNumYear.forEach((item) => {
            activeNumYear[0].data.push([item.DateTime, Number(item.FamilyNum)]);
            activeNumYear[1].data.push([item.DateTime, Number(item.OfficeNum)]);
        });
        timeData.value.yearly.users = activeNumYear;
        // subscribers社区 年月数据保存
        const monthFeeUserMonthNum = [{
                name: 'Subscribers',
                data: []
            }];
        data.MonthFeeUserMonthNumMonth.forEach((item) => {
            monthFeeUserMonthNum[0].data.push([item.DateTime, Number(item.FeeFamilyNum)]);
        });
        timeData.value.monthly.subscribersCommunity = monthFeeUserMonthNum;
        const monthFeeUserMonthNumYear = [{
                name: 'Subscribers',
                data: []
            }];
        data.MonthFeeUserMonthNumYear.forEach((item) => {
            monthFeeUserMonthNumYear[0].data.push([item.DateTime, Number(item.FeeFamilyNum)]);
        });
        timeData.value.yearly.subscribersCommunity = monthFeeUserMonthNumYear;
        // subscribers办公 年月数据保存
        const monthFeeOfficeUserMonthNum = [{
                name: 'Subscribers',
                data: []
            }];
        data.MonthFeeOfficeUserMonthNumMonth.forEach((item) => {
            monthFeeOfficeUserMonthNum[0].data.push([item.DateTime, Number(item.FeeOfficeNum)]);
        });
        timeData.value.monthly.subscribersOffice = monthFeeOfficeUserMonthNum;
        const monthFeeOfficeUserMonthNumYear = [{
                name: 'Subscribers',
                data: []
            }];
        data.MonthFeeOfficeUserMonthNumYear.forEach((item) => {
            monthFeeOfficeUserMonthNumYear[0].data.push([item.DateTime, Number(item.FeeOfficeNum)]);
        });
        timeData.value.yearly.subscribersOffice = monthFeeOfficeUserMonthNumYear;
        // subscribers总数 年月数据保存
        const monthFeeTotalMonth = [{
                name: 'Subscribers',
                data: []
            }];
        data.MonthFeeTotalMonth.forEach((item) => {
            monthFeeTotalMonth[0].data.push([item.DateTime, Number(item.TotalFeeNum)]);
        });
        timeData.value.monthly.subscribersTotal = monthFeeTotalMonth;
        const monthFeeTotalYear = [{
                name: 'Subscribers',
                data: []
            }];
        data.MonthFeeTotalYear.forEach((item) => {
            monthFeeTotalYear[0].data.push([item.DateTime, Number(item.TotalFeeNum)]);
        });
        timeData.value.yearly.subscribersTotal = monthFeeTotalYear;
        // sites住宅 年月数据保存
        const monthFamilyProjectsNumMonth = [{
                name: 'Sites',
                data: []
            }];
        data.MonthFamilyProjectsNumMonth.forEach((item) => {
            monthFamilyProjectsNumMonth[0].data.push([item.DateTime, Number(item.FamilyProjectsNum)]);
        });
        timeData.value.monthly.residentialSitesTrend = monthFamilyProjectsNumMonth;
        const monthFamilyProjectsNumYear = [{
                name: 'Sites',
                data: []
            }];
        data.MonthFamilyProjectsNumYear.forEach((item) => {
            monthFamilyProjectsNumYear[0].data.push([item.DateTime, Number(item.FamilyProjectsNum)]);
        });
        timeData.value.yearly.residentialSitesTrend = monthFamilyProjectsNumYear;
        // sites办公 年月数据保存
        const monthOfficeProjectsNumMonth = [{
                name: 'Sites',
                data: []
            }];
        data.MonthOfficeProjectsNumMonth.forEach((item) => {
            monthOfficeProjectsNumMonth[0].data.push([item.DateTime, Number(item.OfficeProjectsNum)]);
        });
        timeData.value.monthly.officeSitesTrend = monthOfficeProjectsNumMonth;
        const monthOfficeProjectsNumYear = [{
                name: 'Sites',
                data: []
            }];
        data.MonthOfficeProjectsNumYear.forEach((item) => {
            monthOfficeProjectsNumYear[0].data.push([item.DateTime, Number(item.OfficeProjectsNum)]);
        });
        timeData.value.yearly.officeSitesTrend = monthOfficeProjectsNumYear;
        // sites总数 年月数据保存
        const monthProjectsTotalMonth = [{
                name: 'Sites',
                data: []
            }];
        data.MonthProjectsTotalMonth.forEach((item) => {
            monthProjectsTotalMonth[0].data.push([item.DateTime, Number(item.TotalProjectsNum)]);
        });
        timeData.value.monthly.sitesTotalTrend = monthProjectsTotalMonth;
        const monthProjectsTotalYear = [{
                name: 'Sites',
                data: []
            }];
        data.MonthProjectsTotalYear.forEach((item) => {
            monthProjectsTotalYear[0].data.push([item.DateTime, Number(item.TotalProjectsNum)]);
        });
        timeData.value.yearly.sitesTotalTrend = monthProjectsTotalYear;
        // door的relay住宅 年月数据保存
        const monthFamilyRelaysNumMonth = [{
                name: 'Doors',
                data: []
            }];
        data.MonthFamilyRelaysNumMonth.forEach((item) => {
            monthFamilyRelaysNumMonth[0].data.push([item.DateTime, Number(item.FamilyRelayNum)]);
        });
        timeData.value.monthly.residentialDoorsTrend = monthFamilyRelaysNumMonth;
        const monthFamilyRelaysNumYear = [{
                name: 'Doors',
                data: []
            }];
        data.MonthFamilyRelaysNumYear.forEach((item) => {
            monthFamilyRelaysNumYear[0].data.push([item.DateTime, Number(item.FamilyRelayNum)]);
        });
        timeData.value.yearly.residentialDoorsTrend = monthFamilyRelaysNumYear;
        // door的relay办公 年月数据保存
        const monthOfficeRelaysNumMonth = [{
                name: 'Doors',
                data: []
            }];
        data.MonthOfficeRelaysNumMonth.forEach((item) => {
            monthOfficeRelaysNumMonth[0].data.push([item.DateTime, Number(item.OfficeRelayNum)]);
        });
        timeData.value.monthly.officeDoorsTrend = monthOfficeRelaysNumMonth;
        const monthOfficeRelaysNumYear = [{
                name: 'Doors',
                data: []
            }];
        data.MonthOfficeRelaysNumYear.forEach((item) => {
            monthOfficeRelaysNumYear[0].data.push([item.DateTime, Number(item.OfficeRelayNum)]);
        });
        timeData.value.yearly.officeDoorsTrend = monthOfficeRelaysNumYear;
        // door的relay总数 年月数据保存
        const monthRelaysTotalMonth = [{
                name: 'Doors',
                data: []
            }];
        data.MonthRelaysTotalMonth.forEach((item) => {
            monthRelaysTotalMonth[0].data.push([item.DateTime, Number(item.TotalRelaysNum)]);
        });
        timeData.value.monthly.doorsTotalTrend = monthRelaysTotalMonth;
        const monthRelaysTotalYear = [{
                name: 'Doors',
                data: []
            }];
        data.MonthRelaysTotalYear.forEach((item) => {
            monthRelaysTotalYear[0].data.push([item.DateTime, Number(item.TotalRelaysNum)]);
        });
        timeData.value.yearly.doorsTotalTrend = monthRelaysTotalYear;
        // apps住宅 年月数据保存
        const monthFamilyAppsNumMonth = [{
                name: 'Apps',
                data: []
            }];
        data.MonthFamilyAppsNumMonth.forEach((item) => {
            monthFamilyAppsNumMonth[0].data.push([item.DateTime, Number(item.FamilyAppNum)]);
        });
        timeData.value.monthly.residentialAppUserstrend = monthFamilyAppsNumMonth;
        const monthFamilyAppsNumYear = [{
                name: 'Apps',
                data: []
            }];
        data.MonthFamilyAppsNumYear.forEach((item) => {
            monthFamilyAppsNumYear[0].data.push([item.DateTime, Number(item.FamilyAppNum)]);
        });
        timeData.value.yearly.residentialAppUserstrend = monthFamilyAppsNumYear;
        // apps办公 年月数据保存
        const monthOfficeAppsNumMonth = [{
                name: 'Apps',
                data: []
            }];
        data.MonthOfficeAppsNumMonth.forEach((item) => {
            monthOfficeAppsNumMonth[0].data.push([item.DateTime, Number(item.OfficeAppNum)]);
        });
        timeData.value.monthly.officeAppUserstrend = monthOfficeAppsNumMonth;
        const monthOfficeAppsNumYear = [{
                name: 'Apps',
                data: []
            }];
        data.MonthOfficeAppsNumYear.forEach((item) => {
            monthOfficeAppsNumYear[0].data.push([item.DateTime, Number(item.OfficeAppNum)]);
        });
        timeData.value.yearly.officeAppUserstrend = monthOfficeAppsNumYear;
        // apps总数 年月数据保存
        const monthAppsTotalMonth = [{
                name: 'Apps',
                data: []
            }];
        data.MonthAppsTotalMonth.forEach((item) => {
            monthAppsTotalMonth[0].data.push([item.DateTime, Number(item.TotalAppsNum)]);
        });
        timeData.value.monthly.appUsersTotalTrend = monthAppsTotalMonth;
        const monthAppsTotalYear = [{
                name: 'Apps',
                data: []
            }];
        data.MonthAppsTotalYear.forEach((item) => {
            monthAppsTotalYear[0].data.push([item.DateTime, Number(item.TotalAppsNum)]);
        });
        timeData.value.yearly.appUsersTotalTrend = monthAppsTotalYear;
        // 计算所有用户数量
        totalUserNum.value = Number(data.ActiveFamilyNum) + Number(data.OfficeNum);
        nextTick(() => {
            getColumnCountChart('call-container', timeData.value.monthly.callLogs, ['#16D3A6']);
            getColumnCountChart('door-container', timeData.value.monthly.doorLogs, ['#006CFF']);
            getAreaChart('device-container', timeData.value.monthly.devices, ['#23D26A', '#006CFF']);
            getAreaChart('family-container', timeData.value.monthly.subscribersTotal, ['rgba(22, 211, 166, 1)'], 'area');
            getAreaChart('site-container', timeData.value.monthly.sitesTotalTrend, ['rgba(22, 211, 166, 1)'], 'area');
            getAreaChart('apps-container', timeData.value.monthly.appUsersTotalTrend, ['rgba(22, 211, 166, 1)'], 'area');
            getAreaChart('doorRelay-container', timeData.value.monthly.doorsTotalTrend, ['rgba(22, 211, 166, 1)'], 'area');
            getAreaChart('active-container', timeData.value.monthly.users, ['rgba(128, 63, 255, 1)', 'rgba(0, 108, 255, 1)']);
            getPieChart(doorType);
            getGlobalMap(data.GlobalBusiness, type);
        });
    });
    return {
        disList,
        cardInfo,
        totalUserNum
    };
};
const controlTimeType = () => {
    const timeType = ref({
        users: 'monthly',
        subscribers: 'monthly',
        devices: 'monthly',
        callLogs: 'monthly',
        doorLogs: 'monthly',
        sites: 'monthly',
        doors: 'monthly',
        apps: 'monthly'
    });
    const setTimeType = (time, type, extraType) => {
        timeType.value[type] = time;
        if (type === 'users') {
            getAreaChart('active-container', timeData.value[time].users, ['rgba(128, 63, 255, 1)', 'rgba(0, 108, 255, 1)']);
        }
        else if (type === 'subscribers') {
            getAreaChart('family-container', timeData.value[time][extraType], ['rgba(22, 211, 166, 1)'], 'area');
        }
        else if (type === 'sites') {
            getAreaChart('site-container', timeData.value[time][extraType], ['rgba(22, 211, 166, 1)'], 'area');
        }
        else if (type === 'doors') {
            getAreaChart('doorRelay-container', timeData.value[time][extraType], ['rgba(22, 211, 166, 1)'], 'area');
        }
        else if (type === 'apps') {
            getAreaChart('apps-container', timeData.value[time][extraType], ['rgba(22, 211, 166, 1)'], 'area');
        }
        else if (type === 'devices') {
            getAreaChart('device-container', timeData.value[time].devices, ['#23D26A', '#006CFF']);
        }
        else if (type === 'callLogs') {
            getColumnCountChart('call-container', timeData.value[time].callLogs, ['#16D3A6']);
        }
        else if (type === 'doorLogs') {
            getColumnCountChart('door-container', timeData.value[time].doorLogs, ['#006CFF']);
        }
    };
    return {
        timeType,
        setTimeType
    };
};
const subscribersMap = () => {
    const subscribersOptions = [
        { label: 'Subscribers', value: 'subscribers' },
        { label: 'Residential', value: 'residential' },
        { label: 'Office', value: 'office' }
    ];
    const subscribersType = {
        subscribers: {
            label: 'Subscribers',
            value: 'monthFeeUserNumTotal'
        },
        residential: {
            label: 'Residential',
            value: 'monthFeeUserNum'
        },
        office: {
            label: 'Office',
            value: 'monthFeeOfficeUserNum'
        }
    };
    return {
        subscribersOptions,
        subscribersType
    };
};
const subscribersTrendMap = () => {
    const subscribersTrendOptions = [
        { label: 'Subscribers', value: 'subscribersTotal' },
        { label: 'Residential', value: 'subscribersCommunity' },
        { label: 'Office', value: 'subscribersOffice' }
    ];
    const subscribersTrendType = {
        subscribersTotal: {
            label: 'Subscribers'
        },
        subscribersCommunity: {
            label: 'Residential'
        },
        subscribersOffice: {
            label: 'Office'
        }
    };
    return {
        subscribersTrendOptions,
        subscribersTrendType
    };
};
const appUsersMap = () => {
    const appUsersOptions = [
        { label: 'App users', value: 'appUsers' },
        { label: 'Residential', value: 'residential' },
        { label: 'Office', value: 'office' }
    ];
    const appUsersType = {
        appUsers: {
            label: 'App users',
            value: 'totalAppNum'
        },
        residential: {
            label: 'Residential',
            value: 'residentialAppNum'
        },
        office: {
            label: 'Office',
            value: 'officeAppNum'
        }
    };
    return {
        appUsersOptions,
        appUsersType
    };
};
const appUsersTrendMap = () => {
    const appUsersTrendOptions = [
        { label: 'App users trend', value: 'appUsersTotalTrend' },
        { label: 'Residential', value: 'residentialAppUserstrend' },
        { label: 'Office', value: 'officeAppUserstrend' }
    ];
    const appUsersTrendType = {
        appUsersTotalTrend: {
            label: 'App users trend'
        },
        residentialAppUserstrend: {
            label: 'Residential'
        },
        officeAppUserstrend: {
            label: 'Office'
        }
    };
    return {
        appUsersTrendOptions,
        appUsersTrendType
    };
};
const sitesMap = () => {
    const sitesOptions = [
        { label: 'Sites', value: 'sites' },
        { label: 'Residential', value: 'residential' },
        { label: 'Office', value: 'office' }
    ];
    const sitesType = {
        sites: {
            label: 'Sites',
            value: 'totalProjects'
        },
        residential: {
            label: 'Residential',
            value: 'residentialSites'
        },
        office: {
            label: 'Office',
            value: 'officeSites'
        }
    };
    return {
        sitesOptions,
        sitesType
    };
};
const sitesTrendMap = () => {
    const sitesTrendOptions = [
        { label: 'Sites trend', value: 'sitesTotalTrend' },
        { label: 'Residential', value: 'residentialSitesTrend' },
        { label: 'Office', value: 'officeSitesTrend' }
    ];
    const sitesTrendType = {
        sitesTotalTrend: {
            label: 'Sites trend'
        },
        residentialSitesTrend: {
            label: 'Residential'
        },
        officeSitesTrend: {
            label: 'Office'
        }
    };
    return {
        sitesTrendOptions,
        sitesTrendType
    };
};
const doorsMap = () => {
    const doorsOptions = [
        { label: 'Doors', value: 'doors' },
        { label: 'Residential', value: 'residential' },
        { label: 'Office', value: 'office' }
    ];
    const doorsType = {
        doors: {
            label: 'Doors',
            value: 'totalDoors'
        },
        residential: {
            label: 'Residential',
            value: 'residentialDoors'
        },
        office: {
            label: 'Office',
            value: 'officeDoors'
        }
    };
    return {
        doorsOptions,
        doorsType
    };
};
const doorsTrendMap = () => {
    const doorsTrendOptions = [
        { label: 'Doors trend', value: 'doorsTotalTrend' },
        { label: 'Residential', value: 'residentialDoorsTrend' },
        { label: 'Office', value: 'officeDoorsTrend' }
    ];
    const doorsTrendType = {
        doorsTotalTrend: {
            label: 'Doors trend'
        },
        residentialDoorsTrend: {
            label: 'Residential'
        },
        officeDoorsTrend: {
            label: 'Office'
        }
    };
    return {
        doorsTrendType,
        doorsTrendOptions
    };
};
export default null;
export { getGlobalMap, getPieChart, getColumnCountChart, getData, controlTimeType, subscribersMap, subscribersTrendMap, appUsersMap, appUsersTrendMap, sitesMap, sitesTrendMap, doorsMap, doorsTrendMap };
